import { router } from "@inertiajs/react";

// Navigable index of the dev harness pages. Dev-only — the route is mounted
// only under Rails.env.local? (config/routes/dev.rb), never in production.
const HARNESSES: { path: string; title: string; description: string }[] = [
  {
    path: "/video-upload-test",
    title: "Video upload harness",
    description:
      "Browser-upload dropzone, the datacenter-to-datacenter remote fetch, and the player state stub.",
  },
  {
    path: "/brainstorm-stream-test",
    title: "Brainstorm stream harness",
    description: "Tracer bullet for useStream → langgraph-server → brainstorm graph.",
  },
];

export default function DevIndex() {
  return (
    <div className="mx-auto max-w-2xl p-8">
      <h1 className="mb-1 text-xl font-semibold text-base-600">Dev harnesses</h1>
      <p className="mb-6 text-sm text-neutral-400">
        Local-only test pages. Not a product surface.
      </p>

      <ul className="flex flex-col gap-3" data-testid="dev-harness-list">
        {HARNESSES.map((harness) => (
          <li key={harness.path}>
            <button
              type="button"
              onClick={() => router.visit(harness.path)}
              className="w-full rounded-lg border border-neutral-200 p-4 text-left hover:border-primary-400"
            >
              <span className="block text-sm font-medium text-base-600">{harness.title}</span>
              <span className="mt-1 block text-xs text-neutral-400">{harness.description}</span>
              <span className="mt-2 block text-xs text-primary-500">{harness.path}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
